import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"

export const uomLoader = async (): Promise<void> => {
  await useUnitOfMeasurementsStore.getState().getUnits()
}
